<!-- <app-header *ngIf="!router.url.includes('certificate-login') && !router.url.includes('student-login')"></app-header>
<router-outlet *ngIf="router.url.includes('certificate-login') || router.url.includes('student-login')"></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#1354f4" type="line-spin-fade-rotating"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner><ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade-rotating"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner> -->
<!-- <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-spin" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner> -->
<!-- *ngIf="!router.url.includes('student-login')  && !router.url.includes('student-registration')" -->
<!-- *ngIf="router.url.includes('student-login') || router.url.includes('student-registration')" -->

<div *ngIf="isDuplicateTab" style="text-align:center; margin-top: 150px; font-family: Arial, sans-serif;">
  <h2>Duplicate Tab Detected</h2>
  <p>This application is already open in another tab.</p>
  <p>Please close this tab and use the existing one.</p>
</div>

<ng-container *ngIf="!isDuplicateTab">
  <app-header *ngIf="!router.url.includes('certificate-login') && !router.url.includes('student-login')"></app-header>
  <router-outlet
    *ngIf="router.url.includes('certificate-login') || router.url.includes('student-login')"></router-outlet>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#1354f4" type="line-spin-fade-rotating"
    [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade-rotating"
    [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>
</ng-container>